import { Pipe, PipeTransform } from '@angular/core';
import { ContactAddress } from '../../models/contact/contact-address';

@Pipe({
  name: 'primaryAddress'
})
export class PrimaryAddressPipe implements PipeTransform {
  transform(value: ContactAddress[]): ContactAddress {
    if (value.length === 0) {
      var emptyAddress: ContactAddress = {
        id: 0,
        name: '-',
        street: '-',
        postalCode: '-',
        city: '-',
        country: '-',
        isPrimary: false,
        contactId: 0
      }
      return emptyAddress;
    }
    if (value.filter(a => a.isPrimary).length === 0) {
      return value[0];
    }
    return value.filter(a => a.isPrimary)[0]
  }

}
